<template>
  <div>
    <authentication-forms-container :image="image">
      <form v-if="form_step==1 " @submit.prevent="onSubmitForm_1" class="mt-2">
        <h4 class="text-primary" v-t="'register_with_verify_cellphone.title'"></h4>

        <div class="form-group mb-4 mt-3">
          <label for="cellphone" v-t="'authentication_general.cellphone'"></label>
          <input v-model="form_step_1.cellphone" type="text"
                 dir="ltr"
                 :placeholder="$t('authentication_general.cellphone_placeholder')"
                 class="form-control rounded-pill text-left mt-3" id="cellphone">
          <form-errors-manager :validation="v$.form_step_1.cellphone"/>
        </div>

        <div class="my-3">
          <m-captcha1 v-model="form_step_1.captcha_answer"/>
          <form-errors-manager :validation="v$.form_step_1.captcha_answer"/>
        </div>


        <div class="container">
          <input type="checkbox" required class="form-check-input" v-if="showSiteRulesCheckbox">

          <div class="mr-3">
            <i18n-t keypath="term_and_services.text" tag="label">
              <template #terms>
                <router-link class="text-decoration-none" :to="{name:'SinglePage',params:{slug:'terms'}}">
                  {{ $t('term_and_services.terms') }}
                </router-link>
              </template>

              <template #privacy>
                <router-link class="text-decoration-none" :to="{name:'SinglePage',params:{slug:'privacy'}}">
                  {{ $t('term_and_services.privacy') }}
                </router-link>
              </template>

              <template #site_name>
                <span>{{ findAttributeOnSiteInfo('site_name')[0] }}</span>
              </template>

            </i18n-t>
          </div>
        </div>


        <button type="submit" class="my-3 btn-block btn btn-primary rounded-pill w-100"
                v-t="'register_with_verify_cellphone.button_submit'">
        </button>
        <router-link :to="{ name: 'Login' }" class="text-primary mx-2 text-decoration-none"
                     v-t="'register_with_verify_cellphone.login_link'"
        >
        </router-link>
      </form>

      <form v-if="form_step==2 " @submit.prevent="onSubmitForm_2" class="mt-2">
        <h4 class="text-primary" v-t="'register_with_verify_cellphone.title'"></h4>

        <div class="form-row">
          <div class="col">

            <div class="form-group mb-4 mt-3">
              <label for="name" v-t="'authentication_general.name'"></label>
              <input v-model="form_step_2.name" type="text" :placeholder="$t('authentication_general.name_placeholder')"
                     class="form-control rounded-pill mt-3" id="name">
              <form-errors-manager :validation="v$.form_step_2.name"/>
            </div>

          </div>

          <div class="col">

            <div class="form-group mb-4 mt-3">
              <label for="last_name" v-t="'authentication_general.last_name'"></label>
              <input v-model="form_step_2.last_name" type="text"
                     :placeholder="$t('authentication_general.last_name_placeholder')"
                     class="form-control rounded-pill mt-3" id="last_name">
              <form-errors-manager :validation="v$.form_step_2.last_name"/>
            </div>


          </div>
        </div>

        <div class="form-row">
          <div class="col">

            <div class="form-group mb-4 mt-3">
              <label for="code" v-t="'authentication_general.cellphone_verification_code'"></label>
              <input v-model="form_step_2.code" type="text"
                     dir="ltr"
                     :placeholder="$t('authentication_general.cellphone_verification_code_placeholder')"
                     class="form-control rounded-pill text-left mt-3" id="code">
              <form-errors-manager :validation="v$.form_step_2.code"/>
            </div>

          </div>
        </div>


        <div class="form-row" v-if="showPanels && !haveDefaultPanel">
          <p v-t="`authentication_general.register_panels_selection_label`"></p>
          <div class="col-12">
            <div class="form-check form-check-inline" v-for="panel in sitePanels">
              <input v-model="form_step_2.panels" class="form-check-input" type="radio" name="panels"
                     :id="`panel-${panel.id}`"
                     :value="panel.id">
              <label class="form-check-label mx-1" :for="`panel-${panel.id}`">{{ panel.name }}</label>
            </div>
          </div>

          <form-errors-manager :validation="v$.form_step_2.panels"/>

        </div>


        <button type="submit" class="my-3 btn btn-primary rounded-pill btn-block w-100"
                v-t="'register_with_verify_cellphone.button_submit'"
        >
        </button>
        <router-link :to="{ name: 'Login' }" class="text-primary mx-2 text-decoration-none"
                     v-t="'register_with_verify_cellphone.login_link'"
        >
        </router-link>
      </form>

    </authentication-forms-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {useVuelidate} from '@vuelidate/core'
import {integer, maxLength, minLength, required, requiredIf} from "@vuelidate/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import FormErrorsManager from "../../../validator/FormErrorsManager";
import AuthenticationFormsContainer from "../../Form/AuthFormsContainer";
import mCaptcha1 from "../../../Captcha/Captcha1";
import {captchaValidation} from "../../../Captcha/CaptchaValidation";

export default {
  name: "m-register-with-verify-cell-phone-1",
  components: {FormErrorsManager, AuthenticationFormsContainer, mCaptcha1},
  setup() {
    return {v$: useVuelidate()}
  },
  props: {
    image: {
      type: String,
      default: null
    },
    showPanels: {
      type: Boolean,
      default: false,
    },
    defaultPanel: {
      default: '',
    },
    showSiteRulesCheckbox:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      form_step_1: {
        cellphone: "",
        captcha_answer: '',
      },
      form_step_2: {
        name: "",
        last_name: "",
        password: "",
        password_confirmation: "",
        code: "",
        panels: '',
      }
    };
  },
  computed: {
    ...mapGetters({
      form_step: "Authentication/getFormStepOnRegisterWithVerifyPhone",
      sitePanels: "Language/getPanels"
    }),
    haveDefaultPanel() {
      return this.defaultPanel.length > 0
    }
  },
  validations() {
    return {
      form_step_1: {
        cellphone: {required, phone},
        captcha_answer: captchaValidation,
      },
      form_step_2: {
        name: {required},
        last_name: {required},
        code: {required},
        panels: {
          required: requiredIf(function () {
            return this.showPanels && !this.haveDefaultPanel;
          }),
          integer
        },
      }
    }
  },

  methods: {
    async onSubmitForm_1() {
      const result = await this.v$.form_step_1.$validate()
      if (!result) return

      const form = this.form_step_1
      this.$store.dispatch("Authentication/verifyCellPhoneBeforeRegister", form)

    },
    async onSubmitForm_2() {
      const result = await this.v$.form_step_2.$validate()
      if (!result) return

      const form = {...this.form_step_2, ...this.form_step_1,}
      this.$store.dispatch("Authentication/registerWithVerifyCellPhone", form);
    },
  },
  mounted() {
    if (this.showPanels && this.defaultPanel.length > 0) {
      this.form_step_2.panels = this.defaultPanel
    }
  }
};
</script>
<style scoped>

</style>